import {HStack, Show} from 'platform/foundation';

import {useFilter} from '../../../hooks/FilterContext';
import {AdServer} from '../../../types/AdServer';
import {getAdServerRequestArg} from '../utils/getAdServerRequestArg';
import {AdServerLinkButton} from './AdServerLinkButton';
import {AdServerSwitcher} from './AdServerSwitcher';

const NOT_YET_SUPPORTED_AD_SERVER_LINKS = [
  AdServer.AUTOVIT,
  AdServer.BLOCKET,
  AdServer.ENCAR,
  AdServer.HASZNALTAUTO,
  AdServer.KLEINANZEIGEN,
  AdServer.LUXAUTO,
  AdServer.MARKTPLAATS,
  AdServer.TIPCARS,
  AdServer.TWODEHANDS,
  AdServer.VOLVO_SELEKT,
];

export interface AdServerRowProps {
  adServer: AdServer;
  value: boolean;
  onChange: (value: boolean) => void;
  showSwitch: boolean;
  priceReportId: string;
}

export function AdServerRow(props: AdServerRowProps) {
  const {filter} = useFilter();
  const isAdServerLinkSupported = !NOT_YET_SUPPORTED_AD_SERVER_LINKS.includes(props.adServer);
  const requestArg = getAdServerRequestArg({
    filter,
    priceReportId: props.priceReportId,
    adServer: props.adServer,
    isMultiServers: props.showSwitch,
  });

  return (
    <HStack justify="space-between" align="center" spacing={2}>
      <AdServerSwitcher
        adServer={props.adServer}
        value={props.value}
        onChange={props.onChange}
        showSwitch={props.showSwitch}
      />
      <Show when={isAdServerLinkSupported}>
        <AdServerLinkButton requestArg={requestArg} />
      </Show>
    </HStack>
  );
}
